import { appUrl } from 'utils/wrappers';

import Base from 'app/models/base';
import Address from 'app/models/address';
import Tracker from 'app/models/tracker';

export default Base.extend({
  urlRoot: appUrl('insurances'),
  rootKey: 'insurance',
  nestedModels: {
    to_address: Address,
    from_address: Address,
    tracker: Tracker,
  },
});



// WEBPACK FOOTER //
// ./app/models/insurance.js